import { ActionTree, Action } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { PostState } from '@/store/types/post.state';
import db from "@/firebase";
import Post from "@/models/post";

export const actions: ActionTree<PostState, RootState> = {
    async fetchPosts({ commit, state }) {
        const posts: Post[] = [];
        db.collection('posts').onSnapshot((data) => {
            data.docs.map((item, i) => {
                posts[i] = new Post();
                posts[i].id = item.id;
                posts[i].name = item.data().name;
                posts[i].verticalVideoURL = item.data().verticalVideoURL;
                posts[i].horizontalVideoURL = item.data().horizontalVideoURL;
                posts[i].youtubeURL = item.data().youtubeURL;
                posts[i].tools = item.data().tools;
                posts[i].collaboration = item.data().collaboration;
                posts[i].links = item.data().links;
                posts[i].imageURL = item.data().imageURL;
                posts[i].date = item.data().date;
                posts[i].description = item.data().description;
                posts[i].glsl = item.data().glsl;
                posts[i].workInProgress = item.data().workInProgress;
            })
            const post = posts.find((post) => post.id == state.postId);
            commit('setPost', post);
            commit('setPosts', posts);
        });
    },

    async fetchData({ commit, dispatch }) {
        commit('setLoading', true);
        dispatch('fetchPosts');
    },
}